import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { NotificacoesPage } from './notificacoes.page';
import { NotificacoesModel } from 'projects/core/src/lib/core/model/NotificacoesModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';
import { FirebaseWrapper } from 'projects/core/src/lib/core/FirebaseWrapper';
import { ContratoModel } from 'projects/core/src/lib/core/model/ContratoModel';
import { ChaveContratoEnum } from 'projects/core/src/lib/core/ChaveContratoEnum';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';
import { AppSession } from 'projects/core/src/lib/core/AppSession';

export class NotificacoesViewModel {

    notificacoesModel = new NotificacoesModel()
    context: NotificacoesPage

    setContext(context: NotificacoesPage) {
        this.context = context
    }

    getContext(): NotificacoesPage {
        return this.context
    }

    async enviaOpcaoNotificacao(notificacoesModel: NotificacoesModel) {
        let retorno = await this.notificacoesModel.enviaOpcoesNotificacoes(notificacoesModel)
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_CREATED) {
                this.getContext().mensagemSucessoAlteracao('Opção salva com sucesso!')
                this.getContext().obtemOpcoesNotificacao()
            } else {
                this.getContext().mensagemFalhaAlteracao('Não foi possível salvar sua opção. Tente novamente')
            }
        } catch (e) { }
    }

    async obtemOpcoesNotificacao() {
        let retorno = await this.notificacoesModel.obtemOpcoesNotificacoes()
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                this.getContext().setOpcoesNotificacoes(await FirebaseWrapper.trataRetornoPreferenciasNotificacao(retorno.data))
            } else if (retorno.status == ResponseModel.STATUS_NOT_FOUND) {
                // Se não existir uma lista, cadastra uma lista default com todos marcados true
                this.enviaOpcaoNotificacao(this.notificacoesModel);
            }
            else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) { }
    }

    async deletaOpcaoNotificacao() {
        let retorno = await this.notificacoesModel.deletaOpcoesNotificacoes()
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_NO_CONTENT) {
            } else {
                this.getContext().mensagemFalhaAlteracao('Não foi possível deletar suas opçãos. Tente novamente')
            }
        } catch (e) { }
    }

    async hasAPlanWalletRecommendationEnabled() {
        const resultContrato = await AppStorage.get(AppSession.CHAVE_CONTRATO_USUARIO)
        return ContratoModel.existeContratoPorChave(ChaveContratoEnum.CONTRATO_CARTEIRA_RECOMENDADA, resultContrato.contratos)
    }
}